import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLumenComponent } from './simple-icons-lumen.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLumenComponent ],
    exports:      [ SimpleIconsLumenComponent ],
    bootstrap:    []
})
export class SimpleIconsLumenModule {}
